@if (bordered()) {
  <div class="flex flex-col justify-start mb-5">
    <h2 class="text-2xl font-bold mb-2">Utforska fler tjänster</h2>
    <div class="text-base">
      Letar du efter något annat? Se vilka fler tjänster som <a
      [routerLink]="careProviderUnitUrl()">{{ careProviderUnitName() }}</a> erbjuder.
    </div>
  </div>
}

<div class="flex flex-col gap-4">
  @for (careService of careServicesToDisplay(); let i = $index; track careService.id) {
    <div
      [class.has-timeslots]="careServicesTimeSlots()[i]"
      class="w-full border border-grey-8 rounded-lg p-5 bg-white flex flex-col gap-5"
    >
      <div class="flex flex-row gap-4 w-full justify-between items-start">
        <a
          [ngClass]="careService.cssClass"
          [queryParams]="queryParams()"
          [routerLink]="careService.routerLink"
          [title]="careService.name"
        >
          <h3 [innerHtml]="careService.name" class="text-xl font-bold"></h3>
        </a>
        <a [queryParams]="queryParams()"
           [routerLink]="careService.routerLink"
           [title]="careService.name"
           class="underline hidden md:block"
        >
          Läs mer om tjänsten
        </a>
        <a [queryParams]="queryParams()"
           [routerLink]="careService.routerLink"
           [title]="careService.name"
           class="underline block md:hidden"
        >
          <app-ui-icon color="var(--duck-blue-2)" name="arrow_right" size="md"></app-ui-icon>
        </a>
      </div>

      <div class="flex justify-stretch items-start lg:items-center lg:justify-start gap-2 flex-col lg:flex-row">

        @if (careService.isInternal) {
          @if (careServicesTimeSlots()[i]) {
            <div
              class="flex justify-start items-start gap-2 w-full flex-row lg:w-auto lg:justify-start lg:items-center">
              @for (timeslot of careServicesTimeSlots()[i]; let j = $index; track timeslot.label) {
                <app-timeslot-button
                  [class]="'md:inline-block test-timeslot-' + i + '-' + j"
                  [eventAction]="eventActionEnum.VARDEN_BOOKING_CLICK_CARE_SERVICE_TIMESLOT_BTN"
                  [eventCategory]="eventCategoryEnum.VARDEN_BOOKING"
                  [eventLabel]="careService.id.toString()"
                  [eventParams]="careService.dataLayerParams"
                  [ngClass]="{'hidden' : j > 2, 'inline-block': j <= 2, 'sm:inline-block': j < 5, 'lg:hidden': j >= 5, 'xl:inline-block': j >= 5 && j < 7}"
                  [timeslot]="timeslot"
                  appGtmEvent
                  appGtmGa4Event
                ></app-timeslot-button>
              }
            </div>
          } @else {
            <div class="text-base text-apricot-1 font-medium">
              Inga lediga tider den närmaste månaden
            </div>
          }
        } @else {
          @for (config of careService.bookingConfigurationData; track config.id) {
            <app-booking-btn
              [bookingConfigurationData]="config"
              [caregiverContactInfo]="careProviderContactInfo()"
              [class]="'booking-btn'"
              [gaEventAction]="
                      eventActionEnum.VARDEN_BOOKING_CLICK_CARE_SERVICE_BOOKING_BTN
                    "
              [gaEventCategory]="eventCategoryEnum.VARDEN_BOOKING"
              [gaEventLabel]="careService.id.toString()"
              [index]="0"
              [mainCaregiverUnitType]="mainCaregiverUnitType()"
              [pageType]="pageType"
              class="grow lg:grow-0 block w-full lg:w-auto lg:inline-block"
            ></app-booking-btn>
          }
        }
      </div>

      <div class="flex flex-row justify-between">
        @if (careService.isInternal) {
          @for (config of careService.bookingConfigurationData; track config.id) {
            <app-booking-btn
              [bookingConfigurationData]="config"
              [caregiverContactInfo]="careProviderContactInfo()"
              [class]="'text-duck-blue-2 underline text-base booking-btn test-booking-btn' + i"
              [gaEventAction]="
                        eventActionEnum.VARDEN_BOOKING_CLICK_CARE_SERVICE_BOOKING_BTN
                      "
              [gaEventCategory]="eventCategoryEnum.VARDEN_BOOKING"
              [gaEventLabel]="careService.id.toString()"
              [hasTimeslots]="careServicesTimeSlots()[i]?.length > 0"
              [index]="0"
              [isJustLink]="true"
              [label]="'Se alla tillgängliga tider'"
              [mainCaregiverUnitType]="mainCaregiverUnitType()"
              [pageType]="pageType"
            ></app-booking-btn>
          }
        } @else {
          <div></div>
        }

        @if (careService.price > 0) {
          <div class="flex justify-start items-center gap-1 text-apricot-1 text-lg font-bold">
            @if (careService.isFromPrice) {
              <span>fr.</span>
            }
            <span>{{ careService.price }} kr</span>
            @if (careService.priceDescription) {
              <app-ui-icon
                #tooltip="matTooltip"
                (click)="tooltip.show()"
                color="var(--grey-1)" matTooltip="{{ careService.priceDescription }}"
                matTooltipClass="varden-tooltip"
                matTooltipPosition="above"
                name="info"
                size="md"></app-ui-icon>
            }
          </div>
        }
        @if ((careService.price === 0 || careService.price === null) && careService.priceDescription) {
          <div
            class="text-grey-1 text-base">
            {{ careService.priceDescription }}
          </div>
        }
      </div>
    </div>
  }
</div>

